module.exports = __webpack_public_path__ + "img/mmi-moto-logo.eae3ec94.png";